import React from "react";

const NotFound = () => {
  return (
    <div className="container">
      <p>Not Found</p>
    </div>
  );
};

export default NotFound;